export default {
    cn: {
        sidebarList: {
            profitShareView: {
                text: '利润分成设定',
                content: {}
            },
            commissionView: {
                text: '佣金设定',
                content: {}
            },
            commissionView_v2: {
                text: '佣金设定2.0',
                content: {}
            },
            dailyReport: {
                text: '每日总结',
            },
            userList: {
                text: '用户列表',
                content: {},
            },
            accountList: {
                text: '账户列表',
                content: {}
            },
            authList: {
                text: '权限管理',
                content: {}
            },
            indenta: {
                text: '未平仓订单',
                content: {}
            },
            password: {
                text: '修改密码',
                content: {}
            },
            indexb: {
                text: '已平仓订单',
                content: {}
            },
            wasteBook: {
                text: '出入金记录',
                content: {}
            },
            warehouse: {
                text: '仓库总结',
                content: {}
            },
            withdrawal: {
                text: '取款',
                content: {
                    serialNumber: '编号',
                    name: '姓名',
                    email: '电子邮箱',
                    phone: '电话',
                    bank: '银行名称',
                    bankSite: '银行地址',
                    branch: '分行名称',
                    branchProvince: '分行省份',
                    swift: 'SWIFT编码',
                    card: '银行卡号',
                    payee: '收款人',
                    fetch: '可取资金',
                    money: '取款金额',
                    code: '验证码'
                }
            },
            link: {
                text: '专属链接',
                content: {}
            },
            signals: {
                text: '交易信号',
                content: {}
            },
            // 关系图 
            relation: {
                text: '关系图',
                content: {}
            },
            loginSalePlatform: {
                text: '登录销售平台',
                content: {
                    salesId: '销售账号',
                    confirmLogin: '确认登录',
                    succeed: "正在跳转到销售平台，请稍等",
                    err: "输入有误"
                }
            },
            changeParentSales: {
                text: '指派上级',
                content: {
                    account: '登录账号',
                    parentId: '上级账号',
                    agentAccount: '代理账号',
                    comment: '注释',
                    searchAccount: '搜索',
                    assignSales: '指派',
                    succeed: "已成功指派",
                    err: "输入有误",
                    childrenLengthErr: "子下级超过限制，请分批指派"
                }
            },
            clientParentInfo: {
                text: '客户上级信息',
                content: {
                    account: '登录账号',
                    parentId: '上级账号',
                    agentAccount: '代理账号',
                    comment: '注释',
                    searchAccount: '搜索',
                    assignSales: '指派',
                    succeed: "已成功指派",
                    err: "输入有误",
                    childrenLengthErr: "子下级超过限制，请分批指派"
                }
            },
            changepswd: {
                text: '更改密码',
                content: {
                    account: '登录账号',
                    accountName: '账户名称',
                    passworda: '旧密码',
                    passwordb: '新密码',
                    passwordc: '确认密码',
                    okChange: '确认修改',
                    errora: '密码有误',
                    errorb: '新密码和确认密码不一致',
                    errorc: '请输入六位以上的密码',
                    PasswordChangesSucceeded: '密码修改成功',
                    hint: "提示",
                    succeed: "修改成功",
                    err: "输入有误"
                }
            },
            logOut: {
                text: '登出',
                content: {}
            },
        }
    },
    hk: {
        sidebarList: {
            profitShareView: {
                text: '利潤分成設定',
                content: {}
            },
            commissionView: {
                text: '佣金設定',
                content: {}
            },
            commissionView_v2: {
                text: '佣金設定2.0',
                content: {}
            },
            dailyReport: {
                text: '每日總結',
            },
            userList: {
                text: '用戶列表',
                content: {}
            },
            accountList: {
                text: '帳戶列表',
                content: {}
            },
            authList: {
                text: '權限管理',
                content: {}
            },
            indenta: {
                text: '未平倉訂單',
                content: {}
            },
            indexb: {
                text: '已平倉訂單',
                content: {}
            },
            wasteBook: {
                text: '出入金記錄',
                content: {}
            },
            warehouse: {
                text: '倉庫總結',
                content: {}
            },
            withdrawal: {
                text: '取款',
                content: {
                    serialNumber: '編號',
                    name: '姓名',
                    email: '電子郵箱',
                    phone: '電話',
                    bank: '銀行名稱',
                    bankSite: '銀行地址',
                    branch: '分行名稱',
                    branchProvince: '分行省份',
                    swift: 'SWIFT編碼',
                    card: '銀行卡號',
                    payee: '收款人',
                    fetch: '可取資金',
                    money: '取款金額',
                    code: '驗證碼'
                }
            },
            link: {
                text: '專屬連結',
                content: {}
            },
            signals: {
                text: '交易信號',
                content: {}
            },
            // 关系图 
            relation: {
                text: '關系圖',
                content: {}
            },
            loginSalePlatform: {
                text: '登錄銷售平台',
                content: {
                    salesId: '銷售賬號',
                    confirmLogin: '確認登錄',
                    succeed: "正在跳转到销售平台，请稍等",
                    err: "输入有误"
                }
            },
            changeParentSales: {
                text: '指派上級',
                content: {
                    account: '登錄賬號',
                    parentId: '上級賬號',
                    agentAccount: '代理賬號',
                    comment: '註釋',
                    searchAccount: '搜索',
                    assignSales: '指派',
                    succeed: "已成功指派",
                    err: "輸入有誤",
                    childrenLengthErr: "子下級超過限制, 請分批指派"
                }
            },
            clientParentInfo: {
                text: '客戶上級信息',
                content: {
                    account: '登錄賬號',
                    parentId: '上級賬號',
                    agentAccount: '代理賬號',
                    comment: '註釋',
                    searchAccount: '搜索',
                    assignSales: '指派',
                    succeed: "已成功指派",
                    err: "輸入有誤",
                    childrenLengthErr: "子下級超過限制, 請分批指派"
                }
            },
            changepswd: {
                text: '更改密碼',
                content: {
                    account: '帳號',
                    accountName: '帳戶名稱',
                    passworda: '舊密碼',
                    passwordb: '新密碼',
                    passwordc: '確認密碼',
                    okChange: '確認修改',
                    errora: '密碼有誤',
                    errorb: '新密碼和確認密碼不一致',
                    errorc: '請輸入六位以上的密碼',
                    PasswordChangesSucceeded: '密碼修改成功',
                    hint: "提示",
                    succeed: "修改成功",
                    err: "輸入有誤"
                }
            },
            logOut: {
                text: '登出',
                content: {}
            },
        }
    },
    en: {
        sidebarList: {
            profitShareView: {
                text: 'Profit Share Setting',
                content: {}
            },
            commissionView: {
                text: 'Commission Profile Setting',
                content: {}
            },
            commissionView_v2: {
                text: 'Commission Profile Setting 2.0',
                content: {}
            },
            dailyReport: {
                text: 'Daily summary',
            },
            userList: {
                text: 'User List',
                content: {}
            },
            accountList: {
                text: 'Account List',
                content: {}
            },
            authList: {
                text: 'Auth List',
                content: {}
            },
            indenta: {
                text: 'indenta',
                content: {}
            },
            indexb: {
                text: 'indexb',
                content: {}
            },
            wasteBook: {
                text: 'wasteBook',
                content: {}
            },
            warehouse: {
                text: 'warehouse',
                content: {}
            },
            withdrawal: {
                text: 'withdrawal',
                content: {
                    serialNumber: 'serialNumber',
                    name: 'name',
                    email: 'email',
                    phone: 'phone',
                    bank: 'bank',
                    bankSite: 'bankSite',
                    branch: 'branch',
                    branchProvince: 'branchProvince',
                    swift: 'swift',
                    card: 'card',
                    payee: 'payee',
                    fetch: 'fetch',
                    money: 'money',
                    code: 'code'
                }
            },
            link: {
                text: 'link',
                content: {}
            },
            signals: {
                text: 'signals',
                content: {}
            },
            // 关系图 
            relation: {
                text: 'Hierarchy',
                content: {}
            },
            loginSalePlatform: {
                text: 'Login to Sales Portal',
                content: {
                    salesId: 'Sales ID',
                    confirmLogin: 'Login Now',
                    succeed: "is skipping,please,waiting...",
                    err: "input error"
                }
            },
            changeParentSales: {
                text: 'Hierarchy Assignment',
                content: {
                    account: 'Account Number',
                    parentId: 'Parent Account Number',
                    agentAccount: 'Parent Node Code',
                    comment: 'MT4 Comment',
                    searchAccount: 'Search',
                    assignSales: 'Assign',
                    succeed: "assign succeed",
                    err: "input error",
                    childrenLengthErr: "Sub-subordinate exceeds limit, please assign in batches"
                }
            },
            clientParentInfo: {
                text: 'Client Parent Infomation',
                content: {
                    account: 'Account Number',
                    parentId: 'Parent Account Number',
                    agentAccount: 'Parent Node Code',
                    comment: 'MT4 Comment',
                    searchAccount: 'Search',
                    assignSales: 'Assign',
                    succeed: "assign succeed",
                    err: "input error",
                    childrenLengthErr: "Sub-subordinate exceeds limit, please assign in batches"
                }
            },
            changepswd: {
                text: 'Change Password',
                content: {
                    account: 'User ID',
                    accountName: 'Username',
                    passworda: 'Current Password',
                    passwordb: 'New Password',
                    passwordc: 'Re-enter New Password',
                    okChange: 'Change Password',
                    errora: 'wrong password',
                    errorb: 'The new password is different from the confirmation password',
                    errorc: 'Please enter your more then six password over ',
                    PasswordChangesSucceeded: 'Password changes succeeded',
                    hint: "hint",
                    succeed: "succeed",
                    err: "err"
                }
            },
            logOut: {
                text: 'Log out',
                content: {}
            },
        }
    }
}


// WEBPACK FOOTER //
// ./src/MultiLanguage/sidebarList.js